import { render, staticRenderFns } from "./loginBtn.vue?vue&type=template&id=278c7457&scoped=true&"
import script from "./loginBtn.vue?vue&type=script&lang=js&"
export * from "./loginBtn.vue?vue&type=script&lang=js&"
import style0 from "./loginBtn.vue?vue&type=style&index=0&id=278c7457&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c7457",
  null
  
)

export default component.exports